module.exports = __webpack_public_path__ + "static/media/osu-web-header-horiz-rev.8e5a9069.png";